'use client';
import Typography from '@/components/shared/typography/typography.component';

import { useTranslation } from '@/hook';
import { FaultyCheckMark, FixedMark, ImperfectionCheckMark } from '../../../../../public/Images';
import { ImperfectionStatusEnum } from '@/types';
import { ImperfectionStatusLegendItem } from '../StyledComponents/imperfection-section-components';
import Image from 'next/image';

const ImperfectionStatusLegend = ({ status }: { status: ImperfectionStatusEnum }) => {
  const { t } = useTranslation();
  const imperfectionStatusLegendData = {
    UnFaulty: {
      icon: <Image src={ImperfectionCheckMark} width={20} alt="ImperfectionCheckMark" />,
      color: '#00CE7C',
    },
    Fixed: {
      icon: <Image src={FixedMark} width={20} alt="FixedMark" />,
      color: '#00673E',
    },
    Faulty: {
      icon: <Image src={FaultyCheckMark} width={20} alt="FaultyCheckMark" />,
      color: '#DC6803',
    },
  };
  const currentStatus =
    imperfectionStatusLegendData[status as keyof typeof imperfectionStatusLegendData];

  return (
    <ImperfectionStatusLegendItem>
      {currentStatus.icon}
      <Typography
        color={currentStatus.color}
        style={{
          fontWeight: 'bold',
          fontSize: '12px',
          lineHeight: '0',
        }}
      >
        {t(status as keyof typeof imperfectionStatusLegendData)}
      </Typography>
    </ImperfectionStatusLegendItem>
  );
};

export default ImperfectionStatusLegend;
